import { ColumnType } from '../PaginationTable.types';
export const CELL_ID = 'cell';
export const COLUMN_SELECTOR_ID = 'columnselector';
export const HEADER_COLUMN_SELECTOR = 'header-columnselector';
export const TOTALS_ID = 'totals';
export const DEFAULT_SELECTED_COLUMN_COUNT = 5;
export const NOT_CONSIDERED_EMPTY = [0, false];
export const TOTALABLE_COLUMN_TYPES = [ColumnType.CURRENCY, ColumnType.NUMBER, ColumnType.PERCENTAGE];
//# sourceMappingURL=index.js.map